module.exports = __webpack_public_path__ + "static/media/circo2024_trapezio_duo.7ee8a398.webp";